import { useState } from "react";

import { useTranslation } from "@/i18n";
import { PageHeader } from "@/components/shared/page-header";
import { AuditTab } from "@/components/observability/audit-tab";
import { InferenceTab } from "@/components/observability/inference-tab";
import {
  ObservabilityTabs,
  type ObservabilityTab,
} from "@/components/observability/observability-tabs";
import { OverviewTab } from "@/components/observability/overview-tab";
import { PolicyTab } from "@/components/observability/policy-tab";

export default function ObservabilityPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<ObservabilityTab>("overview");

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("observability.page.title")}
        description={t("observability.page.description")}
      />

      <ObservabilityTabs value={activeTab} onChange={setActiveTab} />

      {activeTab === "overview" && <OverviewTab />}
      {activeTab === "inference" && <InferenceTab />}
      {activeTab === "policy" && <PolicyTab />}
      {activeTab === "audit" && <AuditTab />}
    </div>
  );
}
